@if (show) {
  <div class="debug-output no-print" [class.open]="open">
    <i class="icon-robot" (click)="toggleOpen()" title="Debug Informationen"></i>
    @if (open) {
      <div class="content">
        <table>
          <thead>
            <tr>
              <th>Wert</th>
              <th>Daten</th>
            </tr>
          </thead>
          <tbody>
            @for (item of this.data | keyvalue; track item) {
              <tr>
                <td>{{item.value.name}}</td>
                <td>
                  @if (isUrl(item.value.data) === false) {
                    <pre>{{item.value.data | json}}</pre>
                  }
                  @if (isUrl(item.value.data) === true) {
                    <a [href]="item.value.data" target="_blank">Link</a>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
}
